import authFeature from 'src/features/auth/locales/en';
import password from 'src/features/password/locales/en';
import siteTenants from 'src/features/site-tenants/locales/en';
import applications from './applications.json';
import auth from './auth.json';
import common from './common.json';
import components from './components.json';
import invitationSettings from './invitation-settings.json';
import organizationDetails from './organization-details.json';
import publications from './publications.json';
import routes from './routes.json';
import validation from './validation.json';

//hilight
import sitePropertyMembers from 'src/features/property-members/site/locales/en';
import spaces from 'src/features/spaces/site/locales/en';
import mobileAppDisplay from 'src/features/mobile-app-display/shared/locales/en';
import siteMobileAppDisplayHomeScreen from 'src/features/mobile-app-display/site/home-screen/locales/en';
import siteMobileAppDisplayAmenities from 'src/features/mobile-app-display/site/amenities/locales/en';
import siteMobileAppDisplayNewsfeed from 'src/features/mobile-app-display/site/newsfeed/locales/en';
import siteMobileAppDisplayPlaces from 'src/features/mobile-app-display/site/places/locales/en';
import siteMobileAppDisplayServices from 'src/features/mobile-app-display/site/services/locales/en';
import sitePushNotifications from 'src/features/push-notifications/site/locales/en';
import pushNotifications from 'src/features/push-notifications/shared/locales/en';
import siteNews from 'src/features/posts/site/locales/en';
import events from 'src/features/events/shared/locales/en';
import siteEvents from 'src/features/events/site/locales/en';
import sitePlaces from 'src/features/places/site/locales/en';
import polls from 'src/features/surveys/shared/locales/en';
import sitePolls from 'src/features/surveys/site/locales/en';
import sitePartnerships from 'src/features/partnerships/site/locales/en';
import siteGuests from 'src/features/guests/site/locales/en';
import siteBookings from 'src/features/bookings/site/locales/en';
import issues from 'src/features/issues/shared/locales/en';
import siteIssues from 'src/features/issues/site/locales/en';
import siteManagement from 'src/features/administrators/site/locales/en';
import siteContactForm from 'src/features/contact-form/site/locales/en';
import bookings from 'src/features/bookings/site/locales/en';
import siteFaqs from 'src/features/faqs/site/locales/en';

const resources = {
  common,
  auth,
  validation,
  applications,
  organizationDetails,
  invitationSettings,
  routes,
  siteTenants,
  publications,
  events,
  password,
  components,
  authFeature,
  issues,
  sitePropertyMembers,
  spaces,
  mobileAppDisplay,
  siteMobileAppDisplayHomeScreen,
  siteMobileAppDisplayAmenities,
  siteMobileAppDisplayNewsfeed,
  siteMobileAppDisplayPlaces,
  siteMobileAppDisplayServices,
  sitePushNotifications,
  siteNews,
  siteEvents,
  sitePlaces,
  polls,
  sitePolls,
  sitePartnerships,
  siteGuests,
  siteBookings,
  siteIssues,
  siteManagement,
  siteContactForm,
  pushNotifications,
  bookings,
  siteFaqs,
} as const;

export default resources;
